module.exports = __webpack_public_path__ + "img/Pho.b96a39d6.jpg";